import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.EMERALD,
  label: 'emerald',
  tokens: {
    'primary-button': [
      'tw-bg-emerald-600',
      'hover:tw-bg-emerald-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-emerald-200',
      'tw-bg-emerald-100',
      'tw-text-emerald-950',
      'hover:tw-bg-emerald-300',
      'active:tw-bg-emerald-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-emerald-600',
      'tw-text-emerald-900',
      'hover:tw-bg-emerald-50',
      'active:tw-bg-emerald-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],
    'primary-text': ['tw-text-emerald-700'],
    'header-nav': ['!tw-bg-emerald-900'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-emerald-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-emerald-600'],
    'primary-icon': ['tw-fill-emerald-500', 'tw-text-emerald-500'],
    'secondary-icon': [
      'tw-text-emerald-800',
      'tw-bg-emerald-100',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-emerald-800', 'tw-text-emerald-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-emerald-800'],
    'secondary-text': ['tw-text-emerald-500'],
    'linear-gradient': ['tw-to-emerald-500', 'tw-from-emerald-900'],
    'light-linear-gradient': ['tw-bg-emerald-500'],
    'dark-linear-gradient': ['tw-bg-emerald-900'],
    'light-background': ['tw-bg-emerald-50'],
    'dark-background': ['tw-bg-emerald-700'],
    'tracker-dots': ['tw-border-emerald-500', 'tw-bg-emerald-50'],
    'active-tracker-dot': ['tw-bg-emerald-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-emerald-600'],
    'action-flow-button': ['tw-bg-emerald-600', 'hover:tw-bg-emerald-900'],
    'mobile-tracker-line': ['tw-bg-emerald-500'],
    'bottom-nav-active-bar': ['tw-bg-emerald-700'],
    'primary-border': ['tw-border-emerald-500'],
    'dark-border': ['tw-border-emerald-700'],
    'hover-background': ['hover:tw-bg-emerald-50'],
    'hover-border': ['hover:tw-border-emerald-500'],
  },
}

export default config
